const ClosedEye =  ({ width = "30px", fill="#DDD" }) => {
    return (
        <svg x="0px" y="0px" viewBox="0 0 36 36" xmlSpace="preserve" width={width} fill={fill}>
            <path d="M10,8.5c-.5-.5-1.2-.5-1.7,0-.5.5-.5,1.2,0,1.7l1.6,1.6c-5.7,2.3-8.8,6.2-8.8,6.2,0,0,6,7.8,16.8,7.8s3.8-.3,5.4-.7l2.7,2.7c.5.5,1.2.5,1.7,0,.5-.5.5-1.2,0-1.7L10,8.5ZM18,24.7c-3.7,0-6.7-3-6.7-6.7s.4-2.7,1.1-3.7l.9.9c-.5.8-.8,1.8-.8,2.8,0,3,2.4,5.4,5.4,5.4s2-.3,2.8-.8l.9.9c-1.1.7-2.3,1.1-3.7,1.1Z"/>
            <path d="M18,10.2c-1.2,0-2.4.1-3.5.3l1.2,1.2c.7-.3,1.5-.4,2.3-.4,3.7,0,6.7,3,6.7,6.7s-.1,1.6-.4,2.3l3.3,3.3c4.7-2.3,7.2-5.5,7.2-5.5,0,0-6-7.8-16.8-7.8Z"/>
        </svg>
    );
};

export default ClosedEye;